export default __webpack_public_path__ + "static/media/pianorouge.20de0db4.jpg";